import classNames from 'classnames';

export function getClassNames(className: string | null, ...props: any[]): string {
    return classNames(!className ? undefined : `sw-v2-${className}`, ...props);
}
